import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import {
  ICreateRewardPointsDto,
  IMessageResponseDto,
  IRewardPointsBaseWithId,
  IRewardPointsRespDto,
  IScanToEarnGetPriceRespDto,
  IUpdateRewardPointsDto,
} from 'src/types'

class RewardPointsService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getRewardPoints(params?: {}) {
    return this.get<IRewardPointsRespDto>('reward-points/', { params })
  }

  getDefaultRewardPoints() {
    return this.get<IRewardPointsBaseWithId[]>('reward-points/default')
  }

  getScanToEarnReward() {
    return this.get<IScanToEarnGetPriceRespDto>(`reward-points/scan-to-earn`, {})
  }

  createRewardPoint(dto: ICreateRewardPointsDto) {
    return this.post<IMessageResponseDto, ICreateRewardPointsDto>('reward-points/', dto)
  }

  updateRewardPoint(id: string, dto: IUpdateRewardPointsDto) {
    return this.put<IMessageResponseDto, IUpdateRewardPointsDto>(`reward-points/${id}`, dto)
  }

  removeRewardPoints(ids: string[]) {
    return this.delete<IMessageResponseDto>(`reward-points/`, { data: { ids } })
  }
}

export const rewardPointsService = new RewardPointsService()
